import { I18nextProvider } from 'react-i18next';
import { XPProvider } from '@/context/XPContext';
import { StoryBottomBarProvider } from '@/context/StoryBottomBarContext';
import { StoryAudioProvider } from '@/context/StoryAudioContext';
import { PreviewModeProvider } from '@/context/PreviewModeContext';
import { StoryLayout } from '@/components/templates/StoryLayout';
import { StoryDetailPage } from '@/pages/student/StoryDetailPage';
import { useAuth } from '@/hooks/useAuth';
import { studentI18n } from '@/i18n/studentI18n';
import { getUserInitials } from '@/utils/getUserInitials';

export function StoryPreviewPage() {
  const { user } = useAuth();

  const handleClose = () => {
    window.close();
  };

  return (
    <PreviewModeProvider isPreview>
      <I18nextProvider i18n={studentI18n}>
        <XPProvider>
          <StoryBottomBarProvider>
            <StoryAudioProvider>
              <StoryLayout
                userName={user?.name ?? 'Preview'}
                userInitials={user?.name ? getUserInitials(user.name).slice(0, 2) : 'PR'}
                xp={0}
                notificationCount={0}
                onNotificationClick={() => {}}
                onCloseClick={handleClose}
                onProfileClick={() => {}}
                onSettingsClick={() => {}}
                onLogout={() => {}}
                onDropdownOpen={() => {}}
              >
                <StoryDetailPage />
              </StoryLayout>
            </StoryAudioProvider>
          </StoryBottomBarProvider>
        </XPProvider>
      </I18nextProvider>
    </PreviewModeProvider>
  );
}

export default StoryPreviewPage;
